<div class="roi-classification-table__row"
  [class.roi-classification-table__row--excluded]="excludedFromCounter.has(label.id)"
  [class.roi-classification-table__row--selected]="
    !multiSelection && (hasSelectedRois ? isLabelInAllSelectedRois(label.id) : isLabelSelected(label.id))
  " [class.roi-classification-table__row--selectable]="!multiSelection && canEdit && !isIncompatible()"
  [matTooltip]="label.name" [matTooltipDisabled]="!collapsed" matTooltipPosition="right">
  <div class="roi-classification-table__cell roi-classification-table__cell--label">
    <span class="roi-classification-table__color-bar" [style.background-color]="label.color" aria-hidden="true"></span>
    <span class="roi-classification-table__label-actions" *ngIf="!collapsed">
      <ng-container *ngIf="multiSelection; else microProtocolSingleMode">
        <mat-checkbox class="roi-classification-table__label-checkbox" [disabled]="!canEdit || isIncompatible()"
          [checked]="hasSelectedRois ? isLabelInAllSelectedRois(label.id) : isLabelSelected(label.id)" [indeterminate]="
            hasSelectedRois && labelsInSomeSelectedRois.has(label.id) && !isLabelInAllSelectedRois(label.id)
          " (change)="selectLabel.emit(label.id)" (click)="$event.stopPropagation()" [matTooltip]="label.name"
          matTooltipPosition="right" #checkboxTooltip="matTooltip" (mouseleave)="checkboxTooltip.hide()"
          [attr.data-cy]="'button-select-model-option'">
          {{ label.name }}
        </mat-checkbox>
      </ng-container>
      <ng-template #microProtocolSingleMode>
        <span class="roi-classification-table__label-text" [attr.data-cy]="'button-select-model-option'"
          [matTooltip]="label.name" matTooltipPosition="right" #labelTooltip="matTooltip"
          (mouseleave)="labelTooltip.hide()">{{ label.name }}</span>
      </ng-template>
      <span class="roi-classification-table__row-actions">
        <button mat-icon-button class="roi-classification-table__icon-btn"
          [class.roi-classification-table__icon-btn--excluded]="excludedFromCounter.has(label.id)"
          (click)="$event.stopPropagation(); counterLabel.emit(label.id)"
          [matTooltip]="'tooltip.add_remove_to_counter' | translate" [matTooltipShowDelay]="1000"
          matTooltipPosition="right" #counterTooltip="matTooltip" (mouseleave)="counterTooltip.hide()"
          aria-label="Toggle counter" [attr.data-cy]="'button-counter-option'">
          <i [ngClass]="{
              'ri-increase-decrease-line': excludedFromCounter.has(label.id),
              'ri-increase-decrease-fill': !excludedFromCounter.has(label.id)
            }"></i>
        </button>
        <button mat-icon-button class="roi-classification-table__icon-btn"
          (click)="$event.stopPropagation(); pinLabel.emit(label.id)"
          [matTooltip]="'tooltip.pin_unpin_model' | translate" [matTooltipShowDelay]="1000" matTooltipPosition="right"
          #pinTooltip="matTooltip" (mouseleave)="pinTooltip.hide()" aria-label="Toggle pin">
          <i [ngClass]="{
              'ri-pushpin-fill': pinnedLabels.has(label.id),
              'ri-pushpin-line': !pinnedLabels.has(label.id),
              'color-accent': pinnedLabels.has(label.id)
            }"></i>
        </button>
        <button mat-icon-button class="roi-classification-table__icon-btn"
          (click)="$event.stopPropagation(); visibleLabel.emit(label.id)"
          [matTooltip]="'tooltip.view_hide_model' | translate" [matTooltipShowDelay]="1000" matTooltipPosition="right"
          #visibilityTooltip="matTooltip" (mouseleave)="visibilityTooltip.hide()" aria-label="Toggle visibility">
          <i [ngClass]="visibleLabels.includes(label.id) ? 'ri-eye-line' : 'ri-eye-close-line'"></i>
        </button>
      </span>
    </span>
  </div>
  <div class="roi-classification-table__cell roi-classification-table__cell--count-asset">
    <span class="roi-classification-table__count-value">
      {{ displayAssetCount | compactNumber }}
    </span>
  </div>
  <div class="roi-classification-table__cell roi-classification-table__cell--pct-asset">
    <span [class.roi-classification-table__pct--excluded]="excludedFromCounter.has(label.id)">
      {{ assetPctDisplay }}
    </span>
  </div>
  <div class="roi-classification-table__cell roi-classification-table__cell--count">
    <span class="roi-classification-table__count-value">
      {{ displaySampleCount | compactNumber }}
    </span>
  </div>
  <div class="roi-classification-table__cell roi-classification-table__cell--pct">
    <span [class.roi-classification-table__pct--excluded]="excludedFromCounter.has(label.id)">
      {{ samplePctDisplay }}
    </span>
  </div>
</div>
